/**************************************************
 * hooks/usePreventData.js
 *
 * @author  LSJ
 * @since   1.0 (2025-02-28)
 * @version 1.0
 **************************************************/
import { useDashboardData } from "@hooks";

/**
 * usePreventData
 *
 * params 객체를 기반으로 "/user/dash/prevent" 데이터를 불러오는 커스텀 훅.
 * React Query의 useQuery를 사용하여 상태(data, isLoading, isError, error, refetch)를 관리합니다.
 * params 객체는 예: { compCode, otherParam } 와 같이 구성됩니다.
 *
 * @param   {object}  params  API 호출에 사용할 파라미터 객체 (예: { compCode, ... })
 * @returns {object}          { data, isLoading, isError, error, refetch }
 */
const usePreventData = (params) => {
  return useDashboardData("/user/dash/prevent", "preventData", params, "get");
};

export default usePreventData;
